import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import "./App.css";
import LoginPage from "./Pages/Auth/LoginPage";
import ContactUs from "./Pages/ContactUs/ContactUs";
import RequestDemo from "./Pages/RequestDemo/RequestDemo";
import Dashboard from "./Pages/Dashboard/Dashboard";
import AboutUs from "./Pages/AboutUs/AboutUs";
import Main from "./Pages/Home/Main";
import { Provider } from "react-redux";
import { store } from "./Store/store";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },

  {
    path: "/about",
    element: <AboutUs />,
  },
  {
    path: "/contact_us",
    element: <ContactUs />,
  },
  {
    path: "/demo",
    element: <RequestDemo />,
  },
]);

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <RouterProvider router={router} />
      </div>
    </Provider>
  );
}

export default App;
